export default __webpack_public_path__ + "static/media/savagefury.3996c895.png";